import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const chunkErrorPatterns = [
  /ChunkLoadError/i,
  /Loading chunk [\w-]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /Unable to preload CSS/i,
];

export function isStaleChunkError(error: unknown) {
  const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error || '');
  return chunkErrorPatterns.some(pattern => pattern.test(message));
}

type PageModule = Record<string, ComponentType<any>>;

export function lazyPage(loader: () => Promise<PageModule>, exportName: string): LazyExoticComponent<ComponentType<any>> {
  return lazy(async () => {
    const retryKey = `chaotu_admin_chunk_retry:${exportName}`;
    try {
      const module = await loader();
      const component = module[exportName];
      if (!component) throw new Error(`页面模块缺少导出：${exportName}`);
      if (typeof window !== 'undefined') window.sessionStorage.removeItem(retryKey);
      return { default: component };
    } catch (error) {
      if (typeof window !== 'undefined' && isStaleChunkError(error)) {
        const alreadyRetried = window.sessionStorage.getItem(retryKey) === '1';
        if (!alreadyRetried) {
          window.sessionStorage.setItem(retryKey, '1');
          window.location.reload();
          return new Promise<never>(() => {});
        }
        window.sessionStorage.removeItem(retryKey);
      }
      throw error;
    }
  });
}
